/**
 * Ross Header Switcher
 * Shows Ross or default header based on window.partnerContext
 */

(function() {
  'use strict';

  // Configuration
  const ROSS_HEADER_SELECTOR = '#shopify-section-header-ross';
  const DEFAULT_HEADER_SELECTOR = '#shopify-section-header';

  /**
   * Show Ross header and hide default header
   */
  function showRossHeader() {
    const rossHeader = document.querySelector(ROSS_HEADER_SELECTOR);
    const defaultHeader = document.querySelector(DEFAULT_HEADER_SELECTOR);
    
    if (rossHeader) {
      rossHeader.style.display = 'block';
      rossHeader.classList.add('active');
    }
    
    if (defaultHeader) {
      defaultHeader.style.display = 'none';
      defaultHeader.classList.remove('active');
    }
    
    // Update body class for styling
    document.body.classList.add('ross-context');
    document.body.classList.remove('default-context');
    
    // Show Ross signature section and hide default signature section
    const rossSignatureSection = document.getElementById('ross-signature-section');
    const defaultSignatureSection = document.getElementById('default-signature-section');
    
    if (rossSignatureSection) {
      rossSignatureSection.style.display = 'block';
    }
    
    if (defaultSignatureSection) {
      defaultSignatureSection.style.display = 'none';
    }
    
    console.log('Ross header and signature section activated');
  }

  /**
   * Show default header and hide Ross header
   */
  function showDefaultHeader() {
    const rossHeader = document.querySelector(ROSS_HEADER_SELECTOR);
    const defaultHeader = document.querySelector(DEFAULT_HEADER_SELECTOR);
    
    if (defaultHeader) {
      defaultHeader.style.display = 'block';
      defaultHeader.classList.add('active');
    }
    
    if (rossHeader) {
      rossHeader.style.display = 'none';
      rossHeader.classList.remove('active');
    }
    
    // Update body class for styling
    document.body.classList.add('default-context');
    document.body.classList.remove('ross-context');
    
    // Show default signature section and hide Ross signature section
    const rossSignatureSection = document.getElementById('ross-signature-section');
    const defaultSignatureSection = document.getElementById('default-signature-section');
    
    if (defaultSignatureSection) {
      defaultSignatureSection.style.display = 'block';
    }
    
    if (rossSignatureSection) {
      rossSignatureSection.style.display = 'none';
    }
    
    console.log('Default header and signature section activated');
  }

  /**
   * Switch header based on window.partnerContext
   */
  function switchHeader() {
    // Wait for window.partnerContext to be available
    if (typeof window.partnerContext === 'undefined') {
      console.log('window.partnerContext not available yet, retrying...');
      setTimeout(switchHeader, 100);
      return;
    }

    if (window.partnerContext === 'Ross') {
      showRossHeader();
    } else {
      showDefaultHeader();
    }
  }

  /**
   * Initialize the header switcher
   */
  function initHeaderSwitcher() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        // Wait a bit more for window.partnerContext to be set
        setTimeout(switchHeader, 200);
      });
    } else {
      // Wait a bit more for window.partnerContext to be set
      setTimeout(switchHeader, 200);
    }

    // Also listen for changes to window.partnerContext
    let lastPartnerContext = window.partnerContext;
    setInterval(function() {
      if (window.partnerContext !== lastPartnerContext) {
        console.log('Partner context changed from', lastPartnerContext, 'to', window.partnerContext);
        lastPartnerContext = window.partnerContext;
        switchHeader();
      }
    }, 500);
  }

  /**
   * Public API
   */
  window.RossHeaderSwitcher = {
    showRossHeader: showRossHeader,
    showDefaultHeader: showDefaultHeader,
    switchHeader: switchHeader,
    init: initHeaderSwitcher
  };

  // Auto-initialize
  initHeaderSwitcher();

})();
